import { Tag, Text } from '@dixa/lib-shared-habla';
import { Fragment } from 'react';

import { SavedSearchFiltersProps } from '../../savedSearchFilters';

import styles from './savedSearchFiltersItem.module.scss';

export type SavedSearchFiltersItemProps = {
  label: string;
  value: string;
  operator?: string;
  onDelete?: VoidFunction;
} & Pick<SavedSearchFiltersProps, 'variant'>;

export const SavedSearchFiltersItem = ({
  variant,
  label,
  value,
  operator,
  onDelete,
}: SavedSearchFiltersItemProps): JSX.Element => {
  if (variant === 'chips') {
    return (
      <Tag className={styles.filtersChip} onDelete={onDelete} noTruncation>
        <span className={styles.filtersChipLabel}>{label}</span>
        {operator && (
          <span className={styles.filtersChipOperator}>{operator}</span>
        )}
        <span>{value}</span>
      </Tag>
    );
  }

  return (
    <Fragment key={label}>
      <Text.Paragraph variant="4" color="secondary" as="span">
        {label}: {operator} {value}
      </Text.Paragraph>
    </Fragment>
  );
};
